const ALL = 0;
const DaysOptions = [7, 30, 60, ALL];

export {
  ALL,
  DaysOptions,
};
